/**
 * @generated SignedSource<<106e9be7134c4265a34218e18d99d5cf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_issueViewLayoutSingleSelectField_IssueViewSingleSelectField$data = {
  readonly fieldId: string;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"singleSelect_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditView" | "ui_issueViewLayoutFieldHeading_IssueViewFieldHeading">;
  readonly " $fragmentType": "ui_issueViewLayoutSingleSelectField_IssueViewSingleSelectField";
};
export type ui_issueViewLayoutSingleSelectField_IssueViewSingleSelectField$key = {
  readonly " $data"?: ui_issueViewLayoutSingleSelectField_IssueViewSingleSelectField$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueViewLayoutSingleSelectField_IssueViewSingleSelectField">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ui_issueViewLayoutSingleSelectField_IssueViewSingleSelectField",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ui_issueViewLayoutFieldHeading_IssueViewFieldHeading"
    },
    {
      "kind": "FragmentSpread",
      "name": "singleSelect_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditView"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "fieldId"
    }
  ],
  "type": "JiraSingleSelectField"
};

(node as any).hash = "f3ac18890640590f218645ad4a4ae4d6";

export default node;
